import React from 'react';

import { Icon } from 'common/icon';

import { Container, MainContainer } from './styles';

interface Props {
  text?: string;
  icon?: string;
  withDivider?: boolean;
}

export const Subtitle = ({
  text,
  icon,
  children,
  withDivider,
}: React.PropsWithChildren<Props>) => {
  return (
    <MainContainer>
      {withDivider && <p className="text-divider">•</p>}
      <Container>
        {children && children}
        {icon && <Icon icon={icon} />}
        {text && <p>{text}</p>}
      </Container>
    </MainContainer>
  );
};
